export default function Callback() {

    const openModal = (anchor) => {
        if (!anchor) {
            return;
        }

        const modal = document.getElementById(anchor);

        if (modal && modal.classList.contains('callback')) {
            modal.classList.add('callback__open');
        }
    };

    document.querySelectorAll('.toggle-callback')
        .forEach(item => {
            item.addEventListener('click', (e) => {
                let url = item.getAttribute('href'),
                    anchor = url.split('#')[1];
                if (!_.isNil(anchor)) {
                    e.preventDefault();
                    openModal(anchor);
                }

            })
        })

    document.querySelectorAll('.callback__close')
        .forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                let modal = item.closest('.callback');
                modal.classList.remove("callback__open");
            })
        })

    const openModalFromHash = () => {
        openModal(window.location.hash.replace(/^#/, ''));
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', openModalFromHash, {once: true});
    } else {
        openModalFromHash();
    }

    window.addEventListener('load', openModalFromHash, {once: true});
    window.addEventListener('hashchange', openModalFromHash);
/*
    function fieldPreparation(){
        var credentials = Comagic.getCredentials();
        for (var field in credentials) {
            if (credentials.hasOwnProperty(field)){
                document.querySelectorAll('[name=' + field + ']').forEach(ffield => {
                    ffield.value = String(credentials[field]);
                })
            }
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(fieldPreparation, 5000);
    });*/
}
